/* eslint-disable */
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logOut } from '../../redux/authentication/actionCreator';
import { AppRoutes } from '../routes';

function OnBoard(props) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        let token = searchParams.get('token');
        if (searchParams.get('token')) {
            dispatch(logOut(() => {
                navigate(AppRoutes.resetpassword, { state: { token, isInvite: true } })
            }))
        } else {
            navigate('/');
        }
    });

    return (
        <div></div>
    );
}

export default OnBoard;